import {
  getIsModelFlux,
  getIsModelFluxPro,
  getIsModelFluxPro1_1,
  getIsModelFluxPro1_1Ultra,
  getIsModelGptImage,
  getIsModelSdxl,
} from "domains/models/utils";
import { GetModelsByModelIdApiResponse } from "infra/api/generated/api";

export function getDimensionValues(
  model: GetModelsByModelIdApiResponse["model"] | undefined
): {
  width: number;
  height: number;
  ratio: string;
}[] {
  const dimensionsDefault = [
    { width: 1_344, height: 768, ratio: "16:9" },
    { width: 1_216, height: 832, ratio: "3:2" },
    { width: 1_104, height: 832, ratio: "4:3" },
    { width: 1_088, height: 896, ratio: "5:4" },
    { width: 1_024, height: 1_024, ratio: "1:1" },
    { width: 896, height: 1_088, ratio: "4:5" },
    { width: 832, height: 1_104, ratio: "3:4" },
    { width: 832, height: 1_216, ratio: "2:3" },
    { width: 768, height: 1_344, ratio: "9:16" },
  ];

  if (!model || model.type.startsWith("sd-1_5")) {
    return dimensionsDefault.map((dimension) => ({
      width: dimension.width / 2,
      height: dimension.height / 2,
      ratio: dimension.ratio,
    }));
  }

  if (model.id === "flux.1.1-pro-ultra") {
    return [
      { width: 3_136, height: 1_344, ratio: "21:9" },
      { width: 2_752, height: 1_536, ratio: "16:9" },
      { width: 2_496, height: 1_664, ratio: "3:2" },
      { width: 2_368, height: 1_792, ratio: "4:3" },
      { width: 2_304, height: 1_856, ratio: "5:4" },
      { width: 2_048, height: 2_048, ratio: "1:1" },
      {
        width: 1_856,
        height: 2_304,
        ratio: "4:5",
      },
      { width: 1_792, height: 2_368, ratio: "3:4" },
      { width: 1_664, height: 2_496, ratio: "2:3" },
      { width: 1_536, height: 2_752, ratio: "9:16" },
      { width: 1_344, height: 3_136, ratio: "9:21" },
    ];
  }

  if (getIsModelGptImage(model)) {
    return [
      { width: 1_536, height: 1_024, ratio: "3:2" },
      { width: 1_024, height: 1_024, ratio: "1:1" },
      { width: 1_024, height: 1_536, ratio: "2:3" },
    ];
  }

  return dimensionsDefault;
}

export function getIsCustomDimensions({
  model,
  width,
  height,
}: {
  model: GetModelsByModelIdApiResponse["model"] | undefined;
  width: number;
  height: number;
}): boolean {
  return !getDimensionValues(model).some(
    (dimension) => dimension.width === width && dimension.height === height
  );
}

export function getDimensionLimits(
  model: GetModelsByModelIdApiResponse["model"] | undefined
): {
  min: number;
  max: number;
} {
  if (getIsModelFluxPro1_1Ultra(model)) {
    return { min: 1_344, max: 3_136 };
  } else if (getIsModelFluxPro(model) || getIsModelFluxPro1_1(model)) {
    return { min: 256, max: 1_440 };
  } else if (getIsModelFlux(model)) {
    return { min: 128, max: 2_048 };
  } else if (getIsModelSdxl(model)) {
    return { min: 64, max: 2_048 };
  } else if (getIsModelGptImage(model)) {
    return { min: 1_024, max: 1_536 };
  } else {
    return { min: 64, max: 1_024 };
  }
}
